import { useField } from 'components/common-form/hooks/useField';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedNumber } from 'components/shared/Intl';
import { IntWithUnitsValueDefinition } from 'models/metadata/readonlyValue.definition';

interface Props {
  node: IntWithUnitsValueDefinition;
}

export function ProductSummaryIntWithUnitsField({ node }: Props) {
  const { data, metadata } = useField<'IntWithUnitsField'>(node.id);
  const translationKey = node.translationKey ?? node.id;
  return (
    <SummaryFieldRow id={node.id} labelKey={translationKey}>
      <div className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
        <FormattedNumber maximumFractionDigits={4} value={data?.value ?? undefined} />{' '}
        {data?.valueType && metadata.valueTypes?.includes(data.valueType) && data.valueType}
      </div>
    </SummaryFieldRow>
  );
}
